import TApplicationInviteUserUpload from './index.vue';

TApplicationInviteUserUpload.install = app => {
  app.component(TApplicationInviteUserUpload.name, TApplicationInviteUserUpload);
};

export default TApplicationInviteUserUpload;
